var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var PolygonView = require('./polygon-view');

var MultiPolygonView = MultiGeometryViewBase.extend({
  GeometryViewClass: PolygonView
});

module.exports = MultiPolygonView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/geometry-views/leaflet/multi-polygon-view.js
// module id = 1630
// module chunks = 6